import { getLocalizedNameByLocale } from '@mfw/components';
import { type Locale, config } from '@mfw/translations';

export type AppLocale = {
  flag: (typeof config.supportedFlags)[number];
  label?: string;
  value: Locale;
};

export const LOCALES = config.supportedLocales.map((locale, index) => {
  return {
    flag: config.supportedFlags[index],
    label: getLocalizedNameByLocale(locale),
    value: locale,
  };
});

/**
 * The entry to show for a locale — ALWAYS one, never `undefined`.
 *
 * A plain `LOCALES.find(…)` is `AppLocale | undefined`, and the language
 * switcher fed exactly that into `Iconify`'s required `icon` prop. An account
 * holding a locale the app no longer supports therefore rendered the trigger
 * button with no flag in it. The fallback is the default locale, stated here
 * once so no caller has to guard.
 */
export function resolveAppLocale(locale?: string | null): AppLocale {
  return (
    LOCALES.find((available) => available.value === locale) ??
    LOCALES.find((available) => available.value === config.defaultLocale) ??
    LOCALES[0]
  );
}
